/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-06-17 09:37:30
 */
import React, { useState, useMemo } from 'react'
import { Button } from 'antd'
import type { ButtonType } from 'antd/es/button'
import { useAppSelector } from '../../../app/hooks'
import CONFIG from '../../../constants/config'
import FoldersPicker from './FoldersPicker'
import SelectPhotoTip from '../SelectPhotoTip'
import { usePhotosData } from '@/pages/components/photoLib/hooks'
import { PlusOutlined } from '@ant-design/icons'

interface FolderSubmitParams {
  folderIDs: number[]
  submitCallback: () => void
}

interface AddToFolderProps {
  onSubmit?: (params: FolderSubmitParams) => void
  checkedNum?: number
  isRequireCheckPhoto?: boolean
  sensorReport?: () => void
  place?: string
  source?: number
  style?: React.CSSProperties
  isPermanent?: boolean
  dataSource?: 'legacy' | 'location' | 'precise'
}

/**
 * 添加到文件夹组件
 * 支持多种数据源的照片选择
 */
const AddToFolder: React.FC<AddToFolderProps> = ({
  onSubmit,
  checkedNum = 0,
  isRequireCheckPhoto = false,
  sensorReport = () => {
    /* noop:默认不上报 */
  },
  place,
  source,
  style = {},
  isPermanent = false,
  dataSource = 'legacy' // 数据源类型：legacy(传统)、location(位置)、precise(精确)
}) => {
  const [dialogVisible, setDialogVisible] = useState(false)

  // 使用自定义hook获取照片数据
  const { checkedPhotos, checkAll } = usePhotosData(dataSource)

  const myRole = useAppSelector((state) => state.group.myRole)
  const viewPerm = useAppSelector((state) => state.group.viewPerm)

  // 判断按钮是否显示
  const isShow = useMemo(() => {
    if (
      myRole === CONFIG.memberRoleTypes.ADMIN ||
      myRole === CONFIG.memberRoleTypes.MASTER_ADMIN ||
      viewPerm === 0
    ) {
      return !isRequireCheckPhoto || checkedPhotos.length || checkAll
    }

    return false
  }, [checkedPhotos, checkAll, myRole, viewPerm, isRequireCheckPhoto])

  // 按钮组件
  const Btn = () => {
    // 根据来源设置不同的按钮样式
    const btnProps =
      source === 6
        ? {
            type: 'primary' as ButtonType,
            ghost: true
          }
        : {
            type: 'default' as ButtonType,
            ghost: !isShow
          }
    const btn = (
      <Button
        disabled={!isShow}
        {...btnProps}
        style={{
          marginRight: 10,
          ...style
        }}
        onClick={() => {
          sensorReport()
          setDialogVisible(true)
        }}
      >
        {source === 6 ? (
          '复制到'
        ) : (
          <>
            <PlusOutlined />
            文件夹
          </>
        )}
      </Button>
    )

    // 如果是永久显示，则使用SelectPhotoTip包装
    if (isPermanent) {
      return isShow ? btn : <SelectPhotoTip>{btn}</SelectPhotoTip>
    }

    return isShow ? btn : null
  }

  if (isShow || isPermanent) {
    return (
      <>
        <Btn />

        <FoldersPicker
          title={source === 6 ? '复制到文件夹' : '添加至文件夹'}
          visible={dialogVisible}
          checkedNum={checkedNum}
          onClose={() => setDialogVisible(false)}
          onSubmit={onSubmit}
          place={place || ''}
          source={source || 0}
          dataSource={dataSource}
          resource={{}}
        />
      </>
    )
  }

  return null
}

export default AddToFolder
